export default "__VITE_ASSET__CJwnRxc9__"